import { forwardRef } from "react";
import classes from "./Input.module.scss";
import { clsx } from "clsx";
import { InputProps } from "./InputProps";
import { useFormControl } from "@/hooks/useFormControl";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  function Input(props, ref) {
    const {
      className,
      id,
      startAdornment,
      endAdornment,
      hasError,
      size = "medium",
      type = "text",
      onChange,
      ...htmlProps
    } = props;

    const formControl = useFormControl();
    const inputId = id ?? formControl?.id;
    const inputHasError = hasError ?? formControl?.hasError ?? false;

    const inputClasses = clsx(classes.input, classes[size], {
      [classes.endAdornmentSpace]: endAdornment,
      [classes.startAdornmentSpace]: startAdornment,
      [classes.valid]: !inputHasError && formControl?.isValid,
    });

    return (
      <div className={clsx(classes.wrapper, className)}>
        {startAdornment}

        <input
          type={type}
          ref={ref}
          id={inputId}
          className={inputClasses}
          onChange={(e) => {
            if (type === "email" && e.target.value) {
              e.target.value = e.target.value.toLowerCase();
            }
            onChange?.(e);
          }}
          {...(inputHasError && { "aria-invalid": true })}
          {...htmlProps}
        />

        {endAdornment}
      </div>
    );
  },
);
